/* eslint-disable */
<template>
  <div class="cases">
    <Navigation indexProps="3" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Cases</h1></div>
        <div class="header-sub-title">Manage cases and find all bookings, files and requests attached to your case.</div>
      </div>
    </div>
    <div class="panel">
      <CaseMenu indexProps="0" />
      <div class="content">
        <div class="tool-bar row">
          <div class="col d-flex justify-content-end">
            <el-input style="max-width: 180px" class="mr-1" @input="search()" clearable placeholder="Examinee Surname" v-model="listParams.ClaimantSurname"/>
            <el-input style="max-width: 190px" class="mr-1" @input="search()" clearable placeholder="Examinee First Name" v-model="listParams.ClaimantFirstName"/>
            <el-input style="max-width: 100px" class="mr-1" @input="search()" clearable placeholder="Case ID" v-model="listParams.CaseID"/>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th style="width: 50%" class="long-text">Booking Id</th>
                <th style="width:20%" class="long-text">Examinee</th>
                <th style="width:15%" class="long-text">Number of Bookings</th>
                <th style="width:15%" class="long-text">Next Booking</th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="table-responsive">
          <table class="table">
            <tbody>
              <tr v-for="(item, index) in allCases" :key="index" @click="gotoCase(item.id)" class="is-icon">
                <td style="width: 50%" class="long-text">
                  <el-tooltip  effect="dark" :content="item.BookingIDs ? item.BookingIDs.join(', ') : ''" placement="bottom">
                    <span>{{item.BookingIDs ? item.BookingIDs.join(', ') : ''}}</span>
                  </el-tooltip>
                </td>
                <td style="width:20%" class="long-text">{{getClaimantFullNameUpper(item)}}</td>
                <td style="width:15%" class="long-text">{{item.NumberBookings}}</td>
                <td style="width:15%" class="long-text">{{item.NextBookingDate ? formatDate(item.NextBookingDate, 'DD/MM/YYYY hh:mm A', "YYYY-MM-DD HH:mm:ss.ssssss") : null}}</td>
              </tr>
              <tr v-if="allCases.length == 0" class="dox-col">
                No Matching Cases
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="totalCount > listParams.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParams.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParams.pageSize))" :class="listParams.pageNum === item ? 'selected' : ''" :value="item" :key="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount/listParams.pageSize) }}</div>
        </div>
      </div>
    </div>
    <Chat />
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import Navigation from '@/components/Navigation'
import CaseMenu from '@/components/CaseMenu'
import Header from '@/components/Header'
import Chat from '@/components/Chat'
import { debounce } from 'lodash'

export default {
  name: 'Cases',
  components: {
    Navigation,
    CaseMenu,
    Header,
    Chat,
  },
  data() {
    return {
      limit: 20,
      listParams: {
        ClaimantFirstName: '',
        ClaimantSurname: '',
        pageSize: 10,
        pageNum: 1,
        ClientID: null,
        CaseID: null,
      },
      pagination: utilities.initPagination(),
      cases: [],
      allCases: [],
      totalCount: 0,
      searchTerm: '',
      // searchText: "",
      // searchReference: "",
      searchCaseRef: '',
      searchBookingId: '',
      searchClaimantName: '',
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
  },
  methods: {
    getClaimantFullNameUpper(obj) {
      return utilities.getClaimantFullName(obj)
    },
    search: debounce(function () {
      this.selectPage(1)
    }, 800),

    setDateOfEvent(item) {
      if (item.overPeriodofTime) {
        return "Over a Period of Time"
      } else if (item.accidentDate) {
        return this.formatDate(item.accidentDate, 'DD/MM/YYYY')
      } else {
        return ""
      }
    },
    gotoCase(id) {
      this.$router.push({path:'/manage-case', query:{id:id}}).catch((err) => {})
    },

    selectPage(index) {
      this.listParams.pageNum = index
      this.loadData()
    },

    formatDate(date, format = "YYYY-MM-DD", currentFormat = "YYYY-MM-DD") {
      if (date != '' && date != "0000-00-00") {
        return utilities.formatDate(date, format, currentFormat)
      }
      return "";
    },

    paging(cases) {
      if (cases.length == 0 || cases.length <= this.limit) {
        this.cases = cases
        $('.pagination').hide()
      } else {
        this.pagination = utilities.loadPagination(cases, this.limit)
        this.cases = this.pagination.list[this.pagination.current]
        $('.pagination').show()
      }
    },

    async loadData() {
      this.listParams.ClientID = this.user.ClientID

      const {clientCase, total}  = await utilities.getCasesNew(this.listParams)

      this.allCases =  _.cloneDeep(clientCase)
      this.totalCount = total
    },

    // searchByName() {
    //   this.search(this.searchText.trim(), 'claimantFullName')
    // },
    //
    // searchByReference() {
    //   this.search(this.searchReference.trim(), 'caseReference')
    // },

    /*search(text, field) {
      if (text.trim() !== '') {
        var cases = search(this.cases, [field], text)
        if (cases.length > this.limit) {
          this.pagination = utilities.loadPagination(cases, this.limit)
          $('.pagination').show()
        } else {
          this.cases = cases
          $(".pagination").hide()
        }
      } else {
        $(".pagination").hide()
        this.cases = this.allCases
        this.pagination = utilities.loadPagination(this.cases, this.limit)
        this.cases = this.pagination.list[this.pagination.current]
      }
    },
    */
  },

  async beforeMount() {
    this.$store.dispatch('loading/setLoadComponent', true)
    await this.loadData()
    this.$store.dispatch('loading/setLoadComponent', false)
  },

  mounted() {
    $(".clear").on("search", () => {
      this.paging(this.allCases)
    })
  },
}
</script>
